import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { CreateReviewEventDto, ReviewEvent, UpdateReviewEventDto } from '@models/review-event';
import { apiClient } from '.';

export const getReviewEvents = async () => {
  return apiClient.get<PagenatedResponse<ReviewEvent>>(`/admin/v1/review-events`);
};

export const getReviewEvent = async (id: string) => {
  return apiClient.get<ReviewEvent>(`/admin/v1/review-events/${id}`);
};

export const createReviewEvent = async (data: CreateReviewEventDto) => {
  return apiClient.post(`/admin/v1/review-events`, data);
};

export const updateReviewEvent = async (data: UpdateReviewEventDto) => {
  return apiClient.put(`/admin/v1/review-events/${data._id}`, data);
};

export const deleteReviewEvent = async (reviewEventId: string) => {
  return apiClient.delete(`/admin/v1/review-events/${reviewEventId}`);
};

export const selectReviewCandidate = async (reviewEventId: string, reviewId: string) => {
  return apiClient.put(`/admin/v1/review-events/${reviewEventId}/candidates/${reviewId}`);
};

export const excludeReviewCandidate = async (reviewEventId: string, reviewId: string) => {
  return apiClient.delete(`/admin/v1/review-events/${reviewEventId}/candidates/${reviewId}`);
};

export const searchReviewCandidates = async (reviewEventId: string, query?: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<any>>(`/admin/v1/review-events/${reviewEventId}/candidates`, {
    params: query,
  });
};

export const getSelectedReviews = async (reviewEventId: string) => {
  return apiClient.get(`/admin/v1/review-events/${reviewEventId}/selected-reviews`);
};

export const getReviewsExcelFile = async (query?: SearchPagenateQuery) => {
  return apiClient.get(`/admin/v1/reviews/export`, {
    params: query,
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
  });
};

export const getReviewDetail = async (reviewEventId: string, reviewId: string) => {
  return apiClient.get(`/admin/v1/review-events/${reviewEventId}/reviews/${reviewId}`);
};
